import { startFunnelSession, recordFunnelStep, endFunnelSession, getFunnelSessionState } from "@/utils/behaviorTracker";
import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

function resolveWithdrawPageKey(withdrawType) {
  if (withdrawType === "fiat") return PAGE_KEYS.WITHDRAW_FIAT;
  return PAGE_KEYS.WITHDRAW_CRYPTO;
}

function resolvePageKey(pageKey, withdrawType) {
  return pageKey || resolveWithdrawPageKey(withdrawType);
}

export function trackWithdrawEntryClick({ entry, pagePath, pageKey, withdrawType }) {
  startFunnelSession("withdraw");
  recordFunnelStep(1);
  return safeTrack("withdraw_entry_click", {
    page: pagePath || "",
    properties: { entry, page_key: resolvePageKey(pageKey, withdrawType) },
  });
}

export function trackWithdrawPageView({ withdrawType, pagePath, pageKey }) {
  recordFunnelStep(2, { withdrawType });
  return safeTrack("withdraw_page_view", {
    page: pagePath || "",
    properties: { page_key: resolvePageKey(pageKey, withdrawType), withdraw_type: withdrawType },
  });
}

export function trackWithdrawMethodSelect({ currencyId, currency, withdrawType, pagePath, pageKey }) {
  recordFunnelStep(3, { withdrawType });
  return safeTrack("withdraw_method_select", {
    page: pagePath || "",
    properties: {
      page_key: resolvePageKey(pageKey, withdrawType),
      currency_id: Number(currencyId),
      currency: String(currency || "").toUpperCase(),
      withdraw_type: withdrawType,
    },
  });
}

export function trackWithdrawAmountConfirm({ amount, currency, withdrawType, pagePath, pageKey }) {
  recordFunnelStep(4, { withdrawType });
  return safeTrack("withdraw_amount_confirm", {
    page: pagePath || "",
    properties: {
      page_key: resolvePageKey(pageKey, withdrawType),
      amount: String(amount),
      currency: String(currency || "").toUpperCase(),
      withdraw_type: withdrawType,
    },
  });
}

export function trackWithdrawFail({ errorCode, withdrawType, pagePath, pageKey }) {
  return safeTrack("withdraw_fail", {
    page: pagePath || "",
    properties: {
      page_key: resolvePageKey(pageKey, withdrawType),
      error_code: String(errorCode || "UNKNOWN"),
      withdraw_type: withdrawType,
    },
  });
}

export function trackWithdrawAbandon({ lastStep, withdrawType, pagePath, pageKey }) {
  const state = getFunnelSessionState();
  const type = withdrawType || state?.withdrawType || "crypto";
  safeTrack("withdraw_abandon", {
    page: pagePath || "",
    properties: {
      page_key: resolvePageKey(pageKey, type),
      last_step: Number(lastStep != null ? lastStep : state?.lastStep || 1),
      withdraw_type: type,
    },
  });
  endFunnelSession();
}
